<template>
  <nav class="nav-container">
    <div class="search-wrapper">
      <SearchBar @search="handleSearch" />
    </div>
    <div class="nav-wrapper">
      <div class="brand">
        <router-link to="/" class="brand-link">
          <img src="@/assets/logo.png" alt="天门衣尚" class="brand-logo">
          <!-- <span class="brand-name">天门衣尚</span> -->
        </router-link>
      </div>
      <div class="nav-items">
        <router-link v-for="route in routes" :key="route.path" :to="route.path" class="nav-item"
          :class="{ active: currentPath === route.path || isChildActive(route) }">
          {{ route.label }}
          <div v-if="route.children" class="submenu">
            <router-link v-for="child in route.children" :key="child.path" :to="child.path" class="submenu-item"
              :class="{ active: currentPath === child.path }">
              {{ child.label }}
            </router-link>
          </div>
        </router-link>
      </div>
    </div>
  </nav>
</template>

<script setup>
import { computed, defineOptions } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import SearchBar from './Common/SearchBar.vue'

defineOptions({
  name: 'MainNavigation'
})

const router = useRouter()

// 处理搜索结果
const handleSearch = (searchData) => {
  // 跳转到搜索结果页面
  router.push({
    name: 'SearchResult',
    query: {
      category: searchData.category,
      query: searchData.query
    }
  })
}

const route = useRoute()
const currentPath = computed(() => route.path)

const isChildActive = (route) => {
  if (!route.children) return false
  return route.children.some(child => child.path === currentPath.value)
}

const routes = [
  { path: '/', label: '首页' },
  { path: '/news', label: '市场信息' },
  { path: '/supply-demand', label: '供需对接', },
  { path: '/shop', label: '天服商城' },
  { path: '/live', label: '电商服务' },

  { path: '/logistics', label: '物流服务' },
  { path: '/finance', label: '金融服务' },
  {
    path: '/value-added', label: '增值服务',
    children: [
      { path: '/value-added/consulting', label: '招聘服务' },
      { path: '/value-added/job-apply', label: '求职服务' }
    ]
  },
  { path: '/about', label: '关于我们' }
]
</script>

<style scoped>
.nav-container {
  width: 100%;
  background: linear-gradient(to right, rgba(230, 230, 250, 0.95), rgba(238, 238, 255, 0.95));
  box-shadow: 0 2px 8px rgba(147, 112, 219, 0.1);
  position: sticky;
  top: 0;
  z-index: 100;
  transition: all 0.3s ease;
  backdrop-filter: blur(8px);
}

.search-wrapper {
  max-width: 1200px;
  margin: 0 auto;
  background: linear-gradient(120deg, rgba(230, 230, 250, 0.5), rgba(230, 230, 250, 0));
}

.nav-container:hover {
  box-shadow: 0 4px 12px rgba(147, 112, 219, 0.15);
  background: linear-gradient(to right, rgba(230, 230, 250, 0.98), rgba(238, 238, 255, 0.98));
}

.nav-wrapper {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  padding: 0 20px;
  background: linear-gradient(120deg, rgba(230, 230, 250, 0.5), rgba(230, 230, 250, 0));
  gap: 40px;
}

.brand {
  display: flex;
  align-items: center;
}

.brand-link {
  display: flex;
  align-items: center;
  gap: 8px;

  text-decoration: none;
  color: #483D8B;
  transition: transform 0.3s ease;
}

.brand-link:hover {
  transform: scale(1.05);
}

.brand-logo {
  height: 45px; /* 调整原始高度 */
  width: auto;
  margin-right: 10px;
  transform: scale(1.2); /* 适度放大 */
  transition: all 0.3s ease; /* 添加过渡效果 */
  opacity: 0.9; /* 设置透明度 */
  background: linear-gradient(120deg, rgba(230, 230, 250, 0.3), rgba(238, 238, 255, 0.2)); /* 匹配导航栏底色 */
  border-radius: 8px; /* 添加圆角 */
  padding: 4px 8px; /* 添加内边距 */
  backdrop-filter: blur(5px); /* 添加模糊效果 */
}

.brand-logo:hover {
  transform: scale(1.25); /* 鼠标悬停时稍微再放大 */
  opacity: 1; /* 悬停时完全不透明 */
  background: linear-gradient(120deg, rgba(230, 230, 250, 0.5), rgba(238, 238, 255, 0.4)); /* 悬停时加深背景 */
}

.brand-name {
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 1px;
}

.nav-items {
  display: flex;
  align-items: center;
}

.nav-item {
  padding: 0 20px;
  height: 100%;
  display: flex;
  align-items: center;
  color: #483D8B;
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  letter-spacing: 0.5px;
}

.nav-item:hover {
  color: #9370DB;
  transform: translateY(-2px);
  text-shadow: 0 2px 4px rgba(147, 112, 219, 0.1);
}

.nav-item.active {
  color: #9370DB;
  font-weight: 600;
}

.nav-item::before {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 3px;
  background: linear-gradient(90deg, #9370DB, #E6E6FA);
  transition: width 0.3s ease;
  border-radius: 3px;
}

.nav-item:hover::before,
.nav-item.active::before {
  width: 30px;
}

.submenu {
  display: none;
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%) translateY(10px);
  background-color: rgba(230, 230, 250, 0.98);
  box-shadow: 0 4px 16px rgba(147, 112, 219, 0.15);
  border-radius: 8px;
  padding: 8px 0;
  min-width: 140px;
  z-index: 1000;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transform-origin: top center;
}

.nav-item:hover .submenu {
  display: block;
  opacity: 1;
  visibility: visible;
  transform: translateX(-50%) translateY(0);
}

.submenu-item {
  display: block;
  padding: 10px 20px;
  color: #483D8B;
  text-decoration: none;
  font-size: 14px;
  transition: all 0.2s ease;
  text-align: left;
  white-space: nowrap;
  position: relative;
  overflow: hidden;
}

.submenu-item:hover,
.submenu-item.active {
  color: #9370DB;
  background-color: rgba(230, 230, 250, 0.3);
  padding-left: 25px;
}

.submenu-item::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 3px;
  background-color: #9370DB;
  transform: translateX(-3px);
  transition: transform 0.2s ease;
}

.submenu-item:hover::before,
.submenu-item.active::before {
  transform: translateX(0);
}

@media screen and (max-width: 768px) {
  .nav-wrapper {
    justify-content: space-between;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    padding: 0 10px;
  }

  .nav-item {
    padding: 0 12px;
    font-size: 14px;
    white-space: nowrap;
  }

  .submenu {
    position: fixed;
    top: 60px;
    left: 0;
    width: 100%;
    transform: translateY(-10px);
    border-radius: 0;
    box-shadow: 0 4px 12px rgba(147, 112, 219, 0.15);
    background-color: rgba(230, 230, 250, 0.98);
  }

  .nav-item:hover .submenu {
    transform: translateY(0);
  }

  .submenu-item {
    text-align: center;
    padding: 12px 20px;
  }

  .submenu-item:hover {
    padding-left: 20px;
  }

  .submenu-item::before {
    width: 100%;
    height: 3px;
    top: auto;
    bottom: 0;
    transform: translateY(3px);
  }

  .submenu-item:hover::before {
    transform: translateY(0);
  }
}
</style>